export const NAME = 'Mutation';

export class MutationError extends Error {
  constructor(message?: string) {
    super(message || NAME);
    this.name = NAME;
  }
}
